export default {
	"问卷导航": '问卷导航',
	"第": '第',
	"页": '页',
	"本页自定义逻辑编辑": '本页自定义逻辑编辑',
	"页头": '页头',
	"产品": '产品',
	"页尾": '页尾',
	"提示": '提示',
	"当前桌号": '当前桌号',
	"位置信息": '位置信息',
	"选择日期": '选择日期',
	"选择时间": '选择时间',
	"秒": '秒',
	"数据将不会被保存": '注:现在是问卷测试模式，数据将不会被保存',
	'清除测试数据重新开始': '清除测试数据重新开始',
	"问卷页": '问卷页',
	"非常不": '非常不',
	"非常": '非常',
	"文字作答": '文字作答',
	"语音作答": '语音作答',
	"总体喜欢度": '总体喜欢度',
	"肯定购买": '肯定购买',
	"关键指标3": '关键指标3',
	"设置": '设置',
	"性别": '性别',
	"年龄": '年龄',
	"城市": '城市',
	"产品": '产品',
	"开放题": '开放题',
	"当前题号": '当前题号',
	"本题自定义逻辑编辑": '本题自定义逻辑编辑',
	"高级设置": '高级设置',
	"每一行代表一个问题答案": '每一行代表一个问题/答案',
	"制表符": '制表符',
	"覆盖选项": '覆盖选项',
	"追加选项": '追加选项',
	"分隔符": '分隔符',
	"无分隔符": '无分隔符',
	"空格": '空格',
	"逗号": '逗号',
	"值在后": '值在后',
	"选项互斥": '选项互斥',
	"一行显示个数": '一行显示个数',
	"随机选项": '随机选项',
	"实例": '实例',
	"表示值随机": '表示值为1,2,3的选项随机，用英文逗号隔开',
	"不随机选项": '不随机选项',
	"表示值不随机": '表示值为1,2,3的选项不随机，用英文逗号隔开',
	"表示选项互斥": '表示选项1或2和选项3或4和选项5或6或7只能被选中一组（个），其中1234567都为选项的值',
	"全部随机": '全部随机',
	"转置": '转置',
	"使用下拉菜单": '使用下拉菜单',
	"若使用下拉菜单则选项的半开放不生效": '注意：若使用下拉菜单则选项的半开放不生效',
	"答案校验": '答案校验',
	"答案不验证": '答案不验证',
	"答案验证为数字": '答案验证为数字',
	"答案验证为日期": '答案验证为日期',
	"最小值": '最小值',
	"最大值": '最大值',
	"值":'值',
	"唯一性": '唯一性',
	"该答案在本项目唯一": '该答案在本项目唯一',
	"选项倒序": '选项倒序',
	"逐一呈现": '逐一呈现',
	"随机问题": '随机问题',
	"超时记0": '超时记0（否则按实际点击用时记录）',
	"答案设置": '答案设置',
	"排序个数": '排序个数',
	"最小排序数": '最小排序数',
	"最大排序数": '最大排序数',
	"最多上传数量": '最多上传数量',
	"最少上传数量": '最少上传数量',
	"拍照上传": '拍照上传',
	"是否为视频": '是否为视频',
	"是否为图片": '是否为图片',
	"是否允许语音作答":'是否允许语音作答',
	"选项":'选项',
	"批量编辑修改":'批量编辑/修改',
	"列问题":'列问题',
	"行问题":'行问题',
	"问题":'问题',
	"半开放":'半开放',
	"收藏到题库":'收藏到题库',
	"划线内容":'划线内容',
	"不可选":'不可选',
	"行问题随机":'行问题随机',
	"答案必须是数字":'答案必须是数字',
	"问题管理":'问题管理',
	"问卷管理":'问卷管理',
	"点击获取定位":'点击获取定位',
	"量表类型":'量表类型',
	"类型名称":'类型名称',
	"选择数量":'选择数量',
	"量表样式":'量表样式',
	"同一个设备只能填一次":'同一个设备只能填一次',
	"不能为空":'不能为空',
	"设置桌号":'设置桌号',
	"开始":'开始',
	"当前桌号":'当前桌号',
	"有误":'有误',
  "选择日期":'选择日期',
  "选择时间":'选择时间',
  "全部":'全部',
	"起始数值":'起始数值',
	"不显示数值":'不显示数值',
  "显示雷达图":'显示雷达图',
  "冻结题目":'冻结题目',
  "您已参与过该项目请勿重复参与":'您已参与过该项目，请勿重复参与',
  "上传图片":'上传图片',
  "冻结选项":'冻结选项'

}